export default "__VITE_ASSET__C7Gwv$GM__"